import { setActiveLanguage } from 'react-localize-redux';
import moment from 'moment';
// Reducer and action creators are from react-localize-redux

export default function switchLanguage(lang) {
  return function (dispatch) {
    window.localStorage.setItem('lang', lang);
    moment.locale(lang);

    dispatch(setActiveLanguage(lang));
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/i18n.js